<template functional>
  <div>
    <div
      v-for="(warehouse, index) in props.item.warehouses"
      :key="index"
      class="cname"
    >
      {{ warehouse.city }}
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-warehouse-city",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
